export const ONBOARDING_TEXT_COLOR = '#5c5470';
export const ONBOARDING_LINK_COLOR = '#9254de';
